import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';

import styles from './index.module.sass';

interface WarningLabelProps {
  label: string;
}

export const WarningLabel: React.FC<WarningLabelProps> = ({ label }) => {
  if ( !label || !label.trim().length ) return null;

  return (
    <div className={styles.container}>
      <FontAwesomeIcon className={styles.icon} icon={faTriangleExclamation} />
      {label}
    </div>
  );
};
